
export function getShopBadgeClass(index: number) {
  const classes = [
    {
      bg: "bg-[#EFF6FF]",
      text: "text-[#1D4ED8]",
      border: "border-[#BFDBFE]",
      dot: "bg-[#2563EB]",
    },
    {
      bg: "bg-[#F0FDF4]",
      text: "text-[#15803D]",
      border: "border-[#BBF7D0]",
      dot: "bg-[#16A34A]",
    },
    {
      bg: "bg-[#FFF7ED]",
      text: "text-[#C2410C]",
      border: "border-[#FED7AA]",
      dot: "bg-[#EA580C]",
    },
    {
      bg: "bg-[#FDF4FF]",
      text: "text-[#7E22CE]",
      border: "border-[#E9D5FF]",
      dot: "bg-[#9333EA]",
    },
    {
      bg: "bg-[#FFF1F2]",
      text: "text-[#BE123C]",
      border: "border-[#FECDD3]",
      dot: "bg-[#E11D48]",
    },
  ];

  return classes[index % classes.length];
}